// Nav

import { NavLink } from 'react-router-dom';

const Nav = ({ navOpen, hideNav }) => (

	<nav className={navOpen ? "main-nav active" : "main-nav not-active"} >
        <ul>
            <li><NavLink onClick={hideNav} to={'/'} exact>Home</NavLink></li>
            <li><NavLink onClick={hideNav} to={'/about'}>About</NavLink></li>
            <li><NavLink onClick={hideNav} to={'/work'}>Work</NavLink></li>
            <li><NavLink onClick={hideNav} to={'/contact'}>Contact</NavLink></li>
        </ul>
	</nav>
    
);

export default Nav;